import _slicedToArray from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _get from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import has from 'lodash/has';
import _snakeCase from 'lodash/snakeCase';
import _camelCase from 'lodash/camelCase';
import mapKeys from 'lodash/mapKeys';
import mapValues from 'lodash/mapValues';
import { getter } from 'property-expr';
import { object as locale } from './locale';
import sortFields from './util/sortFields';
import sortByKeyOrder from './util/sortByKeyOrder';
import runTests from './util/runTests';
import ValidationError from './ValidationError';
import BaseSchema from './schema';
var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};
function unknown(ctx, value) {
  var known = Object.keys(ctx.fields);
  return Object.keys(value).filter(function (key) {
    return known.indexOf(key) === -1;
  });
}
var defaultSort = sortByKeyOrder([]);
var ObjectSchema = /*#__PURE__*/function (_BaseSchema) {
  function ObjectSchema(spec) {
    var _this;
    _classCallCheck(this, ObjectSchema);
    _this = _callSuper(this, ObjectSchema, [{
      type: 'object'
    }]);
    _this.fields = Object.create(null);
    _this._sortErrors = defaultSort;
    _this._nodes = [];
    _this._excludedEdges = [];
    _this.withMutation(function () {
      _this.transform(function coerce(value) {
        if (typeof value === 'string') {
          try {
            value = JSON.parse(value);
          } catch (err) {
            value = null;
          }
        }
        if (this.isType(value)) return value;
        return null;
      });
      if (spec) {
        _this.shape(spec);
      }
    });
    return _this;
  }
  _inherits(ObjectSchema, _BaseSchema);
  return _createClass(ObjectSchema, [{
    key: "_typeCheck",
    value: function _typeCheck(value) {
      return isObject(value) || typeof value === 'function';
    }
  }, {
    key: "_cast",
    value: function _cast(_value) {
      var _this2 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$stripUnknown;
      var value = _get(_getPrototypeOf(ObjectSchema.prototype), "_cast", this).call(this, _value, options); //should ignore nulls here

      if (value === undefined) return this.getDefault();
      if (!this._typeCheck(value)) return value;
      var fields = this.fields;
      var strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
      var props = this._nodes.concat(Object.keys(value).filter(function (v) {
        return _this2._nodes.indexOf(v) === -1;
      }));
      var intermediateValue = {}; // is filled during the transform below

      var innerOptions = _extends({}, options, {
        parent: intermediateValue,
        __validating: options.__validating || false
      });
      var isChanged = false;
      var _iterator = _createForOfIteratorHelper(props),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var prop = _step.value;
          var field = fields[prop];
          var exists = has(value, prop);
          if (field) {
            var fieldValue = void 0;
            var inputValue = value[prop]; // safe to mutate since this is fired in sequence

            innerOptions.path = (options.path ? "".concat(options.path, ".") : '') + prop; // innerOptions.value = value[prop];

            field = field.resolve({
              value: inputValue,
              context: options.context,
              parent: intermediateValue
            });
            var fieldSpec = 'spec' in field ? field.spec : undefined;
            var strict = fieldSpec == null ? void 0 : fieldSpec.strict;
            if (fieldSpec == null ? void 0 : fieldSpec.strip) {
              isChanged = isChanged || prop in value;
              continue;
            }
            fieldValue = !options.__validating || !strict ?
            // TODO: use _cast, this is double resolving
            field.cast(value[prop], innerOptions) : value[prop];
            if (fieldValue !== undefined) {
              intermediateValue[prop] = fieldValue;
            }
          } else if (exists && !strip) {
            intermediateValue[prop] = value[prop];
          }
          if (intermediateValue[prop] !== value[prop]) {
            isChanged = true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return isChanged ? intermediateValue : value;
    }
  }, {
    key: "_validate",
    value: function _validate(_value) {
      var _this3 = this;
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments.length > 2 ? arguments[2] : undefined;
      var errors = [];
      var sync = opts.sync,
        _opts$from = opts.from,
        from = _opts$from === void 0 ? [] : _opts$from,
        _opts$originalValue = opts.originalValue,
        originalValue = _opts$originalValue === void 0 ? _value : _opts$originalValue,
        _opts$abortEarly = opts.abortEarly,
        abortEarly = _opts$abortEarly === void 0 ? this.spec.abortEarly : _opts$abortEarly,
        _opts$recursive = opts.recursive,
        recursive = _opts$recursive === void 0 ? this.spec.recursive : _opts$recursive;
      from = [{
        schema: this,
        value: originalValue
      }].concat(_toConsumableArray(from)); // this flag is needed for handling `strict` correctly in the context of
      // validation vs just casting. e.g strict() on a field is only used when validating

      opts.__validating = true;
      opts.originalValue = originalValue;
      opts.from = from;
      _get(_getPrototypeOf(ObjectSchema.prototype), "_validate", this).call(this, _value, opts, function (err, value) {
        if (err) {
          if (!ValidationError.isError(err) || abortEarly) {
            return void callback(err, value);
          }
          errors.push(err);
        }
        if (!recursive || !isObject(value)) {
          callback(errors[0] || null, value);
          return;
        }
        originalValue = originalValue || value;
        var tests = _this3._nodes.map(function (key) {
          return function (_, cb) {
            var path = key.indexOf('.') === -1 ? (opts.path ? "".concat(opts.path, ".") : '') + key : "".concat(opts.path || '', "[\"").concat(key, "\"]");
            var field = _this3.fields[key];
            if (field && 'validate' in field) {
              field.validate(value[key], _extends({}, opts, {
                // @ts-ignore
                path: path,
                from: from,
                // inner fields are always strict:
                // 1. this isn't strict so the casting will also have cast inner values
                // 2. this is strict in which case the nested values weren't cast either
                strict: true,
                parent: value,
                originalValue: originalValue[key]
              }), cb);
              return;
            }
            cb(null);
          };
        });
        runTests({
          sync: sync,
          tests: tests,
          value: value,
          errors: errors,
          endEarly: abortEarly,
          sort: _this3._sortErrors,
          path: opts.path
        }, callback);
      });
    }
  }, {
    key: "clone",
    value: function clone(spec) {
      var next = _get(_getPrototypeOf(ObjectSchema.prototype), "clone", this).call(this, spec);
      next.fields = _extends({}, this.fields);
      next._nodes = this._nodes;
      next._excludedEdges = this._excludedEdges;
      next._sortErrors = this._sortErrors;
      return next;
    }
  }, {
    key: "concat",
    value: function concat(schema) {
      var _this4 = this;
      var next = _get(_getPrototypeOf(ObjectSchema.prototype), "concat", this).call(this, schema);
      var nextFields = next.fields;
      for (var _i = 0, _Object$entries = Object.entries(this.fields); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          field = _Object$entries$_i[0],
          schemaOrRef = _Object$entries$_i[1];
        var target = nextFields[field];
        if (target === undefined) {
          nextFields[field] = schemaOrRef;
        } else if (target instanceof BaseSchema && schemaOrRef instanceof BaseSchema) {
          nextFields[field] = schemaOrRef.concat(target);
        }
      }
      return next.withMutation(function () {
        return next.shape(nextFields, _this4._excludedEdges);
      });
    }
  }, {
    key: "getDefaultFromShape",
    value: function getDefaultFromShape() {
      var _this5 = this;
      var dft = {};
      this._nodes.forEach(function (key) {
        var field = _this5.fields[key];
        dft[key] = 'default' in field ? field.getDefault() : undefined;
      });
      return dft;
    }
  }, {
    key: "_getDefault",
    value: function _getDefault() {
      if ('default' in this.spec) {
        return _get(_getPrototypeOf(ObjectSchema.prototype), "_getDefault", this).call(this);
      } // if there is no default set invent one

      if (!this._nodes.length) {
        return undefined;
      }
      return this.getDefaultFromShape();
    }
  }, {
    key: "shape",
    value: function shape(additions) {
      var excludes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var next = this.clone();
      var fields = Object.assign(next.fields, additions);
      next.fields = fields;
      next._sortErrors = sortByKeyOrder(Object.keys(fields));
      if (excludes.length) {
        // this is a convenience for when users only supply a single pair
        if (!Array.isArray(excludes[0])) excludes = [excludes];
        next._excludedEdges = [].concat(_toConsumableArray(next._excludedEdges), _toConsumableArray(excludes));
      }
      next._nodes = sortFields(fields, next._excludedEdges);
      return next;
    }
  }, {
    key: "pick",
    value: function pick(keys) {
      var picked = {};
      var _iterator2 = _createForOfIteratorHelper(keys),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var key = _step2.value;
          if (this.fields[key]) picked[key] = this.fields[key];
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return this.clone().withMutation(function (next) {
        next.fields = {};
        return next.shape(picked);
      });
    }
  }, {
    key: "omit",
    value: function omit(keys) {
      var next = this.clone();
      var fields = next.fields;
      next.fields = {};
      var _iterator3 = _createForOfIteratorHelper(keys),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var key = _step3.value;
          delete fields[key];
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return next.withMutation(function () {
        return next.shape(fields);
      });
    }
  }, {
    key: "from",
    value: function from(_from, to, alias) {
      var fromGetter = getter(_from, true);
      return this.transform(function (obj) {
        if (obj == null) return obj;
        var newObj = obj;
        if (has(obj, _from)) {
          newObj = _extends({}, obj);
          if (!alias) delete newObj[_from];
          newObj[to] = fromGetter(obj);
        }
        return newObj;
      });
    }
  }, {
    key: "noUnknown",
    value: function noUnknown() {
      var noAllow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : locale.noUnknown;
      if (typeof noAllow === 'string') {
        message = noAllow;
        noAllow = true;
      }
      var next = this.test({
        name: 'noUnknown',
        exclusive: true,
        message: message,
        test: function test(value) {
          if (value == null) return true;
          var unknownKeys = unknown(this.schema, value);
          return !noAllow || unknownKeys.length === 0 || this.createError({
            params: {
              unknown: unknownKeys.join(', ')
            }
          });
        }
      });
      next.spec.noUnknown = noAllow;
      return next;
    }
  }, {
    key: "unknown",
    value: function unknown() {
      var allow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : locale.noUnknown;
      return this.noUnknown(!allow, message);
    }
  }, {
    key: "transformKeys",
    value: function transformKeys(fn) {
      return this.transform(function (obj) {
        return obj && mapKeys(obj, function (_, key) {
          return fn(key);
        });
      });
    }
  }, {
    key: "camelCase",
    value: function camelCase() {
      return this.transformKeys(_camelCase);
    }
  }, {
    key: "snakeCase",
    value: function snakeCase() {
      return this.transformKeys(_snakeCase);
    }
  }, {
    key: "constantCase",
    value: function constantCase() {
      return this.transformKeys(function (key) {
        return _snakeCase(key).toUpperCase();
      });
    }
  }, {
    key: "describe",
    value: function describe() {
      var base = _get(_getPrototypeOf(ObjectSchema.prototype), "describe", this).call(this);
      base.fields = mapValues(this.fields, function (value) {
        return value.describe();
      });
      return base;
    }
  }]);
}(BaseSchema);
export { ObjectSchema as default };
export function create(spec) {
  return new ObjectSchema(spec);
}
create.prototype = ObjectSchema.prototype;